import { createI18n } from "vue-i18n";

import { customRule, customRuRule } from "@/locales/customRules";

let locale = localStorage.getItem("locale");
if (!locale) {
  localStorage.setItem("locale", "uz");
  locale = "uz";
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
  fallbackLocale: "ru",
  messages: {},
  locale,
  pluralRules: {
    ru: customRuRule,
    uz: customRule,
  },
  runtimeOnly: false,
});

export async function loadMessages() {
  const [ru, uz] = await Promise.all([
    import("@/locales/ru").then((m) => m.default?.() ?? m.ru?.() ?? m()),
    import("@/locales/uz").then((m) => m.default?.() ?? m.uz?.() ?? m()),
  ]);

  i18n.global.setLocaleMessage("ru", ru);
  i18n.global.setLocaleMessage("uz", uz);
}

export default i18n;
